import styled from '@emotion/styled';
import { VariableSizeList } from 'react-window';

export const TransactionsList = styled.div`
  display: flex;
  flex: 1 1 auto;
  padding: 0;
  margin: 0;
  height: 100%;
`;

export const List = styled(VariableSizeList)`
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translateZ(0);

  ::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }

  &:hover {
    ::-webkit-scrollbar-thumb {
      visibility: visible !important;
    }
  }

  ::-webkit-scrollbar-thumb {
    visibility: ${({ showScrollThumb }) =>
      showScrollThumb ? 'visible' : 'hidden'};
    background-color: var(--background-neutral-hovered);
  }

  :cn ::-webkit-scrollbar-button:start:decrement {
    background: #0000;
    display: none;
  }

  ::-webkit-scrollbar-track-piece:vertical:start {
    border-radius: 4px 4px 0 0;
  }

  ::-webkit-scrollbar-track-piece:vertical:end {
    border-radius: 0 0 4px 4px;
  }

  ::-webkit-scrollbar-track-piece:horizontal:start {
    border-radius: 4px 0 0 4px;
  }

  ::-webkit-scrollbar-track-piece:horizontal:end {
    border-radius: 0 4px 4px 0;
  }
`;
